import { Fragment } from "react";
import { CommentForm } from "../commentForm";
import { Box, Typography } from "@mui/material";
import { CommentType } from "./types";
import { useTranslation } from "react-i18next";
import { NoResponse } from "../../../../../../../../components/errors/noResponse";
import { NoComments } from "../../../../../../../../components/errors/noComments";

export const Comment = ({
    commentForm,
    addComment,
    comments,
    addCommentBtn,
}: CommentType) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                height: "100%", // Altura completa disponible
            }}
        >
            {/* Contenedor de Comentarios (con scroll) */}
            <Box
                sx={{
                    flex: 1, // Ocupa el espacio disponible verticalmente
                    overflowY: "auto", // Scroll solo aquí
                    padding: "0 5rem",
                }}
            >
                {/* Renderizar Comentarios */}
                {!!comments?.length &&
                    comments.map((itemComments, index) => (
                        <Fragment key={index}>
                            <Box
                                sx={{
                                    borderRadius: "8px",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                                    padding: "12px 16px",
                                    marginBottom: "12px",
                                    backgroundColor: "#fff",
                                }}
                            >
                                {/* Información del Usuario */}
                                <Typography
                                    sx={{
                                        fontSize: "12px",
                                        fontWeight: 500,
                                        color: "#A6A6A6",
                                        marginBottom: "4px",
                                    }}
                                >
                                    {itemComments.user ?? "Usuario Desconocido"}
                                </Typography>

                                {/* Descripción o Mensaje */}
                                <Typography
                                    sx={{
                                        fontSize: "14px",
                                        fontWeight: 400,
                                        color: "#333333",
                                        marginBottom: "8px",
                                    }}
                                >
                                    {itemComments.description ?? ""}
                                </Typography>

                                {/* Fecha del Comentario */}
                                <Typography
                                    sx={{
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color: "#1976D2",
                                        textAlign: "right",
                                    }}
                                >
                                    {itemComments.date ?? ""}
                                </Typography>
                            </Box>
                        </Fragment>
                    ))}

                {/* No hay información */}
                {!addComment && !comments?.length && (
                    <NoComments label={t("reportFolio.detail.general.noComments")} />
                )}
            </Box>

            {/* Formulario fijo al final */}
            <Box
            >
                <CommentForm {...commentForm} />
            </Box>
        </Box>
    );
};
